export default "__VITE_ASSET__1046c860__"